import * as React from 'react'

import Breadcrumbs from '../Breadcrumbs.component'
import * as ReactMarkdown from 'react-markdown'
import renderers from 'react-markdown-github-renderers'

import AccidentsContent from './Accidents.md'

import 'github-markdown-css/github-markdown.css'

class DocumentationPage extends React.PureComponent {
  render() {
    return (
      <div>
        <Breadcrumbs breadcrumbs={[
          { name: 'Dashboard', link: '/dashboard' },
          { name: 'Accidents', link: '/accidents' },
          { name: 'Documentation', active: true }
        ]} />

        <div className="page">
          <div className="align-items-center mb-2">
            <ReactMarkdown
              escapeHtml={false}
              source={AccidentsContent}
              className="markdown-body"
            />
          </div>
        </div>

      </div>
    )
  }
}

export default DocumentationPage



// WEBPACK FOOTER //
// ./src/routes/docs/Documentation.page.tsx